import React from 'react';

import { SearchMdIcon } from 'assets/svg/landing/searchIcons';
import { splitLabelOnMatch } from 'utils/landingSearch';

interface Props {
    label: string;
    /** What the user has typed so far; drives the regular/medium weight split. */
    query: string;
    onSelect: (label: string) => void;
    testId: string;
}

/**
 * One autocomplete row.
 *
 * Figma renders the typed portion regular and the completion after it medium, so the eye lands on
 * what the row adds rather than on what was already typed.
 */
function LandingSearchSuggestion({ label, query, onSelect, testId }: Props) {
    const { head, tail } = splitLabelOnMatch(label, query);

    return (
        <button
            type="button"
            data-testid={testId}
            onClick={() => onSelect(label)}
            className="flex w-full items-center gap-4 break-words text-left font-lg text-filterV2TextPrimary"
        >
            <SearchMdIcon className="size-6 shrink-0" />
            <span className="min-w-px flex-[1_0_0]">
                <span className="font-normal">{head}</span>
                {tail && <span className="font-medium">{tail}</span>}
            </span>
        </button>
    );
}

export default LandingSearchSuggestion;
